import { useQuery } from "react-query";
import { getSubjects, getSubjectsPlans } from "../services/school/subject/getSubjects";
import { PagedRequestType } from "../types/PagedResults";
import { Key_subjectplans } from "../utils/constants";

export const useGetSubjectsQuery = (pagedRequest?: PagedRequestType, options:any= null) => {
    return useQuery(
      ['subjects-pagination', JSON.stringify(pagedRequest)],
      () => getSubjects(pagedRequest),
      options?{...options}:{}
    );
  };
export const useGetSubjectsPlansQuery = (pagedRequest?: PagedRequestType, options:any= null) => {
    return useQuery(
      [Key_subjectplans, JSON.stringify(pagedRequest)],
      () => getSubjectsPlans(pagedRequest),
      options?{...options}:{}
    );
  };